export const PermissionEnum = {
  LOG_HOURS: 'LOG_HOURS',
  VIEW_ANALYTICS: 'VIEW_ANALYTICS',
  EXPORT_DATA: 'EXPORT_DATA',
  VIEW_FINANCIALS: 'VIEW_FINANCIALS',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  PROJECT_MANAGEMENT: 'PROJECT_MANAGEMENT',
  VIEW_AUDIT_LOG: 'VIEW_AUDIT_LOG',
  IS_ADMIN: 'IS_ADMIN',
  IS_MAINTAINER: 'IS_MAINTAINER',
} as const;

export type Permission = (typeof PermissionEnum)[keyof typeof PermissionEnum];

export interface User {
  id: string;
  name: string;
  email: string;
  permissions: Permission[];
  managerId?: string | null;
  manager?: { id: string; name: string } | null;
  jobTitleId?: string | null;
  jobTitle?: { id: string; name: string } | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
}

export interface JobTitle {
  id: string;
  name: string;
  costRate?: number | null;
  revenueRate?: number | null;
  userCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface JwtPayload {
  sub: string;
  email: string;
  permissions: Permission[];
  isApprover: boolean;
  iat: number;
  exp: number;
}